var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"to-the-top"},[_c('div',{staticClass:"scale"},[_c('RateButton',{attrs:{"icon":_vm.icon,"clicked":_vm.icon}}),_c('div',{staticClass:"thanks"},[_vm._v("Спасибо за отзыв")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }